import { render, staticRenderFns } from "./AllCollectionLeaderTask.vue?vue&type=template&id=25a3cf97&scoped=true"
import script from "./AllCollectionLeaderTask.vue?vue&type=script&lang=js"
export * from "./AllCollectionLeaderTask.vue?vue&type=script&lang=js"
import style0 from "./AllCollectionLeaderTask.vue?vue&type=style&index=0&id=25a3cf97&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a3cf97",
  null
  
)

export default component.exports